// Subprojects functionality
// Currently using direct links instead of modals

$(document).ready(() => {
  // Future subprojects-specific JavaScript can go here
});
